import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import { Redirect } from "react-router-dom";
import EssenceReference from "../../Essence/EssenceReference";
import EssenceReferenceSchedulerEdit from "../../Essence/EssenceReferenceSchedulerEdit";
import "moment/locale/ru";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import SuperSelect from "../../Misc/SuperSelect";

export default class TaskAdd extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      cancel: false,
      redirect: false,
      showSchedulerReference: false,
      schedule: {},
      data: {},
      types: null,
      staff: null,
    };
  }
  componentDidMount() {
    this.load();
  }

  load = async () => {
    this.setState({ pending: true });
    let types = await this.context.api.qo("/task/type");
    let staff = await this.context.api.qo("/staff/list");
    this.setState({ types, staff, pending: false });
  };

  onChange = (e) => {
    let data = this.state.data;
    const id = e.target.id;
    const value = e.target.value;

    data[id] = value;
    this.setState({ data });
  };

  dateTimeChange = (key, value) => {
    if (value instanceof Object) {
      this.setState((state) => {
        let data = state.data;
        data[key] = value.toDate();
        return { data };
      });
    }
  };

  cancel = () => {
    this.setState({ pending: true, cancel: true });
  };

  save = async () => {
    let data = this.state.data;

    if (!this.context.user.isAdmin) {
      data.executor = this.context.user.staffId;
    }
    let saveData = {
      type: this.context.getType(data.typecode) || null,
      label: data.label || null,
      datefrom: data.datefrom || null,
      dateto: data.dateto || null,
      description: data.description,
      executor: data.executor || null,
      parent: data.parent || null,
      priority: data.priority || null,
    };

    this.setState({ pending: true });
    let result = await this.context.api.q("/task/set", saveData);
    if (result !== false) {
      this.context.toast("Задача сохранена", "success");
      if (result.id) {
        this.setState({ redirect: `/tasks/current/` });
      } else {
        this.setState({ cancel: true });
      }
    } else {
      this.context.toast("Не удалось сохранить задачу", "error");
      this.setState({ pending: false });
    }
  };

  onHideSchedulerReference = () => {
    this.setState({ showSchedulerReference: false });
  };

  onSelectSchedule = (schedule) => {
    this.setState({ schedule });
  };

  render() {
    let data = this.state.data;
    let types = this.state.types || {};
    let staff = this.state.staff || {};

    if (this.state.cancel) {
      return <Redirect to="/tasks/current/" />;
    }

    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    return (
      <>
        <EssenceReference
          essence="scheduler"
          title="Расписания"
          showDescription
          showType
          show={this.state.showSchedulerReference}
          onHide={this.onHideSchedulerReference}
          onSelect={this.onSelectSchedule}
          itemEditor={(itemEditorProps) => (
            <EssenceReferenceSchedulerEdit {...itemEditorProps} />
          )}
        />
        <div className="d-flex justify-content-center">
          <div className="card card-custom col-lg-6">
            <div className="card-header">
              <div className="card-title">
                <h3 className="card-label">Добавить задачу</h3>
              </div>
            </div>
            <div className="card-body">
              <Blocker on={this.state.pending}>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>Тип:</label>
                      <select
                        className="form-control"
                        id="typecode"
                        onChange={(e) => this.onChange(e)}
                        value={data.typecode}
                      >
                        <option value={""}></option>
                        {Object.entries(types).map(([id, type]) => (
                          <option key={id} value={type.code}>
                            {type.description}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>Приоритет: </label>
                      <SuperSelect
                        cache
                        forcePath="/priority"
                        onChange={(value) =>
                          this.onChange({
                            target: {
                              id: "priority",
                              value,
                            },
                          })
                        }
                        essence="priority"
                        nameField="name"
                        idField="id"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>Начало задачи:</label>
                      <Datetime
                        value={data.datefrom ? new Date(data.datefrom) : ""}
                        onChange={(v) => this.dateTimeChange("datefrom", v)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>Окончание задачи:</label>
                      <Datetime
                        value={data.dateto ? new Date(data.dateto) : ""}
                        onChange={(v) => this.dateTimeChange("dateto", v)}
                      />
                    </div>
                  </div>
                </div>

                {this.context.user.isAdmin ? (
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>Исполнитель:</label>
                        <select
                          className="form-control"
                          id="executor"
                          onChange={(e) => this.onChange(e)}
                          value={data.executor}
                        >
                          <option value={""}></option>
                          {Object.entries(staff).map(([id, item]) => (
                            <option key={id} value={id}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div className="form-group">
                        <label>Привязать объект с ID:</label>
                        <input
                          type="text"
                          className="form-control mb-3"
                          value={data.parent || ""}
                          id="parent"
                          onChange={(e) => this.onChange(e)}
                        />
                      </div>
                    </div>
                  </div>
                ) : null}

                <div className="form-group">
                  <label>Наименование:</label>
                  <input
                    type="text"
                    className="form-control mb-3"
                    value={data.label || ""}
                    id="label"
                    onChange={(e) => this.onChange(e)}
                  />
                </div>

                <div className="form-group">
                  <label>Описание:</label>
                  <textarea
                    type="text"
                    className="form-control mb-3"
                    value={data.description}
                    id="description"
                    onChange={(e) => this.onChange(e)}
                  />
                </div>

                <div className="form-group">
                  <button
                    onClick={() => this.save()}
                    className="btn btn-primary mr-2"
                  >
                    Сохранить
                  </button>
                  <button
                    onClick={() => this.cancel()}
                    className="btn btn-light"
                  >
                    Отмена
                  </button>
                </div>
              </Blocker>
            </div>
          </div>
        </div>
      </>
    );
  }
}
